import type { Collection } from '@/types/collection';
import type { CategoryHeader } from '@/utils/pages/api';

/**
 * Type guard to check if pageData is a Collection
 */
export const isCollection = (
  pageData: CategoryHeader | Collection
): pageData is Collection => 'thumbnail_image' in pageData;
